import React from 'react';
import styled from 'styled-components';

const ResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: 30px;
  max-width: 100%;
  
  @media (max-width: 768px) {
    gap: 20px;
  }
`;

const ResultCard = styled.div`
  background: rgba(255, 255, 255, 0.1);
  width: 70vw;
  max-width: 300px;
  border-radius: 20px;
  padding: 30px;
  text-align: center;
  color: white;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  
  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const RoundTitle = styled.h2`
  font-size: 1.8rem;
  margin-bottom: 20px;
  color: #ffd700;
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 15px;
  }
`;

const ScoreInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 25px;
`;

const ScoreItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  
  &:last-child {
    border-bottom: none;
  }
`;

const ScoreLabel = styled.span`
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.8);
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const ScoreValue = styled.span`
  font-size: 1.2rem;
  font-weight: bold;
  color: #00eaff;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

const LevelUpButton = styled.button`
  padding: 15px 30px;
  border: none;
  border-radius: 25px;
  font-size: 1.2rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  background: var(--primary-gradient);
  color: white;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(255, 107, 107, 0.6);
  }
`;

const RoundResult = ({ result, onLevelUp }) => {
  return (
    <ResultContainer>
      <ResultCard>
        <RoundTitle> {result.round} Round 완료!</RoundTitle>
        <ScoreInfo>
          <ScoreItem>
            <ScoreLabel>점수</ScoreLabel>
            <ScoreValue>{result.score.toLocaleString()}{/*/{result.maxScore.toLocaleString()}*/}</ScoreValue>
          </ScoreItem>
          <ScoreItem>
            <ScoreLabel>최대 콤보</ScoreLabel>
            <ScoreValue>{result.combo}</ScoreValue>
          </ScoreItem>
        </ScoreInfo>
        
        <div style={{fontSize: '0.7rem', color: 'rgba(255, 187, 0, 0.85)', height: '30px', fontWeight: 'bold'}}>
          {result.round === 1 ? '3라운드까지 플레이하면 응모할 수 있어요!!' : '이제 마지막 라운드! 파이팅!!'}
        </div>
        <LevelUpButton onClick={onLevelUp}>
          레벨업
        </LevelUpButton>
      </ResultCard>
    </ResultContainer>
  );
};

export default RoundResult; 